import styled from 'styled-components'

export const Container = styled.header`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  margin: 1rem 0;

  .container {
    align-items: center;
    /* background-color: aqua; */
    display: flex;
    /* border: 2px solid #fff; */
    justify-content: center;
    flex-direction: column;
    /* background-color: rgba(255, 255, 255, 0.2);  */
    border-radius: 30px;
    /* padding: 10px; */
    width: 100%;
    /* backdrop-filter: blur(10px); */
  }

  section {
    z-index: 1;
  }

  .infos {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;

    img {
      border-radius: 10%;
      margin-right: 0.5rem;
      width: 4.5rem;
    }

    .info-box {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      text-align: left;
      width: 100%;
      img {
        display: none;
      }
    }
  }

  .links {
    align-items: center;
    display: flex;
    justify-content: flex-start;
    margin: 1rem 0;
    width: 100%;

    a {
      text-decoration: none;
      margin-left: 1rem;
    }

    a:first-of-type {
      margin-left: 0;
    }

    img {
      border-radius: 10%;
      margin-right: 0.5rem;
      width: 1.5rem;
    }
  }

  h1 {
    font-size: 1.5rem;
  }

  p {
    text-align: left;
  }

  .box {
    align-items: center;
    border-radius: 20px;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px 15px;
  }

  .box::before {
    content: '';
    position: absolute;
    width: 130%;
    height: 30%;
    background-color: #fff;
    animation: animate 5s linear infinite;
  }

  @keyframes animate {
    100% {
      transform: rotate(360deg);
    }
  }

  .box::after {
    content: '';
    position: absolute;
    background-color: #000;
    inset: 5px;
    border-radius: inherit;
  }

  @media only screen and (min-width: 1000px) {
    height: 40rem;

    article {
      /* width: 32rem; */
      /* background-color: red; */
    }

    .name {
      width: 30rem;
      h1 {
        text-align: left;
        width: 100%;
      }
    }

    .infos {
      /* width: 30rem; */
      padding: 0;
      justify-content: space-between;
      img {
        width: 100%;
        margin: 0;
      }

      .img-box {
        /* background-color: red !important; */
        width: 25%;
      }

      .info-box {
        /* background-color: red !important; */

        p {
          font-size: 1.3rem;
        }
        width: 73%;

        img {
          display: flex;
          width: 15rem;
        }
      }
    }

    .links {
      /* background-color: red; */
      width: 30rem;
      a {
        margin: 0;
        margin-right: 1rem;
        transition: transform 0.3s ease;
      }

      a:hover {
        cursor: pointer;
        transform: scale(1.5) rotate(360deg);
      }
    }

    h1 {
      font-size: 2.1rem;
    }

    .box {
      width: 32rem;
      padding: 10px 20px;
    }
  }
`
